<template>
  <div>
    <div class="page-title">
      <span>{{ title }}</span>
    </div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm">
      <el-form-item :label="translateWords.ProductName" prop="ProductName">
        <el-input v-model="ruleForm.ProductName"></el-input>
        <el-button type="primary" @click="showwptable" v-if="showwpbutton">引用网片</el-button>
      </el-form-item>
      <el-form-item :label="translateWords.ProductCode" prop="ProductCode"><el-input v-model="ruleForm.ProductCode"></el-input></el-form-item>
      <el-form-item :label="translateWords.ModelType" prop="ModelType"><el-input v-model="ruleForm.ModelType"></el-input></el-form-item>
      <el-form-item :label="translateWords.ProductType" prop="ProductType">
        <el-select v-model="ruleForm.ProductType" :placeholder="translateWords.select" filterable style="width:400px">
          <el-option v-for="item in ProductTypeoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="translateWords.SumStorage" prop="SumStorage">
        <el-input :placeholder="translateWords.inputNumber" v-model.number="ruleForm.SumStorage" :disabled="Type == 'edit'"></el-input>
      </el-form-item>

      <el-form-item v-if="Type == 'edit'" :label="translateWords.CanBeUseStorage" prop="CanBeUseStorage">
        <el-input :placeholder="translateWords.inputNumber" v-model.number="ruleForm.CanBeUseStorage"></el-input>
      </el-form-item>

      <el-form-item v-show="false" :label="translateWords.SupplierCode" prop="SupplierCode"><el-input v-model="ruleForm.SupplierCode"></el-input></el-form-item>
      <el-form-item v-show="false" :label="translateWords.NewOrOld" prop="NewOrOld">
        <el-select v-model="ruleForm.NewOrOld" :placeholder="translateWords.select" filterable style="width:400px">
          <el-option v-for="item in NewOrOldoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="translateWords.room" prop="PositionId">
        <el-select v-model="ruleForm.PositionId" :placeholder="translateWords.select" filterable @change="selectvalue(ruleForm.PositionId, 'PositionId')" style="width:400px">
          <el-option v-for="item in x_PositionIdoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="translateWords.RackId" prop="RackId">
        <el-select v-model="ruleForm.RackId" :placeholder="translateWords.select" filterable @change="selectvalue(ruleForm.RackId, 'RackId')" style="width:400px">
          <el-option v-for="item in RackIdoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="translateWords.Status" prop="Status">
        <el-select v-model="ruleForm.Status" :placeholder="translateWords.select" filterable style="width:400px">
          <el-option v-for="item in Statusoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-upload
          action=""
          class="upload-demo"
          drag
          :on-preview="handlePreview"
          :before-remove="beforeRemove"
          :file-list="fileList"
          list-type="picture"
          :show-file-list="true"
          :before-upload="beforeupload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            {{ translateWords.uploadTip }}
            <em>{{ translateWords.clickUpload }}</em>
          </div>
          <div class="el-upload__tip" slot="tip">{{ translateWords.loadTip }}</div>
        </el-upload>
      </el-form-item>

      <el-form-item :label="translateWords.Remark" prop="Remark">
        <el-input type="textarea" :rows="2" placeholder="" v-model="ruleForm.Remark"></el-input>
      </el-form-item>

      <el-form-item style="float:left">
        <el-button type="primary" @click="submitForm('ruleForm')">{{ translateWords.save }}</el-button>
        <el-button type="primary" @click="resetForm('ruleForm')">{{ translateWords.reset }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import WP from '@/components/WP';
  import { importScript } from '../util/importScript';

  export default {
    name: 'AddSample',
    props: ['PositionIdoptions', 'title'],
    components: {
      WP,
    },
    data() {
      return {
        x_PositionIdoptions: this.PositionIdoptions || [],
        translateWords: {
          ProductName: '产品名称',
          ProductCode: '产品条码',
          ProductType: '产品类别',
          select: '请选择',
          SumStorage: '总库存',
          CanBeUseStorage: '可借库存',
          inputNumber: '请输入数字',
          SupplierCode: '供应商代码',
          NewOrOld: '新旧品',
          room: '位置',
          RackId: '货架-货架层',
          Status: '状态',
          uploadTip: '将文件拖到此处，或',
          clickUpload: '点击上传',
          loadTip: '可以上传多张照片，上传格式jpg/png文件，且不超过2M',
          Remark: '备注',
          save: '保存',
          reset: '重置',
          countTip: '请输入不小于0的数量',
          ProductTypeTip: '请选择产品类别',
          NewOrOldTip: '请选择新旧品',
          selectRoom: '请选择房间',
          selectRack: '请选择货架货架层',
          saveFail: '保存失败',
          saveSuccess: '保存成功',
          getRackFail: '获取货架失败',
          uploadPicFail: '上传图片只能是jpg / png 格式!',
          picMaxSize: '图片最大2M!',
          uploadFail: '上传失败',
          containtab: '产品名称不能包含特殊字符',
          ModelType: '型号',
        },
        ruleForm: {
          ProductName: '',
          ProductCode: '',
          ProductType: '',
          SumStorage: 0,
          CanBeUseStorage: 0,
          SupplierCode: '',
          NewOrOld: '',
          PositionId: '',
          RackId: '',
          Status: '',
          Sys_Guid: '',
          Remark: '',
          gsfj: [],
          ModelType: '',
        },
        rules: {
          PositionId: [{ required: true, message: '请选择一个房间' }],
          ProductName: [{ required: true, message: '请输入产品名称' }],
          ProductCode: [{ required: true, message: '请输入产品条码' }],
          ProductType: [{ required: true, message: '请选择产品类别' }],
          //   SupplierCode:[
          //  { required: true, message: '输入供应商代码'}
          // ],
          //   NewOrOld:[
          //  { required: true, message: '请选择新旧品'}
          // ],
          Status: [{ required: true, message: '请选择状态' }],
          RackId: [{ required: true, message: '请选择货架' }],
          SumStorage: [
            { required: true, message: '请输入数量' },
            { type: 'number', message: '请输入不小于0的数量' },
          ],
          CanBeUseStorage: [
            { required: true, message: '请输入数量' },
            { type: 'number', message: '请输入不小于0的数量' },
          ],
        },
        uid: this.$route.query.uid,
        token: this.$route.query.token,
        lang: this.$route.query.lang,
        ProductTypeoptions: [],
        NewOrOldoptions: [],
        RackIdoptions: [],
        RackLayeroptions: [],
        Statusoptions: [],
        fileList: [],
        imgurls: '',
        Type: '',
        showwp: false,
        showwpbutton: false,
      };
    },
    created() {
      // this.IsUseRackLayeroptions=this.$store.getters.getinitstatus;
      // this.IsUseRackoptions=this.$store.getters.getinitstatus;
      // this.Statusoptions=this.$store.getters.getinitstatus;
      // this.ProductTypeoptions=this.$store.getters.getproducttype;
      // this.NewOrOldoptions=this.$store.getters.getneworold;
      // this.getinitstatus();
      // this.getneworold();
      // this.getproducttype();
      this.gsfj = this.PositionIdoptions;
    },
    mounted() {
      var that = this;
      importScript(this.baseurl, () => {
        that.translateWord();
      });
    },
    methods: {
      translateWord() {
        var that = this;

        if (window.jsT) {
          for (const key in that.translateWords) {
            this.translateWords[key] = window.jsT.T(that.translateWords[key]);
          }

          this.ruleForm.Status = window.jsT.T(this.ruleForm.Status);

          this.rules = {
            PositionId: [{ required: true, message: window.jsT.T('请选择一个房间') }],
            ProductName: [{ required: true, message: window.jsT.T('请输入产品名称') }],
            ProductCode: [{ required: true, message: window.jsT.T('请输入产品条码') }],
            ProductType: [{ required: true, message: window.jsT.T('请选择产品类别') }],
            //   SupplierCode:[
            // { required: true, message: window.jsT.T('输入供应商代码')}
            // ],
            //   NewOrOld:[
            // { required: true, message: window.jsT.T('请选择新旧品')}
            // ],
            Status: [{ required: true, message: window.jsT.T('请选择状态') }],
            RackId: [{ required: true, message: window.jsT.T('请选择货架') }],
            SumStorage: [
              { required: true, message: window.jsT.T('请输入数量') },
              { type: 'number', message: window.jsT.T('请输入不小于0的数量') },
            ],
            CanBeUseStorage: [
              { required: true, message: window.jsT.T('请输入数量') },
              { type: 'number', message: window.jsT.T('请输入不小于0的数量') },
            ],
          };
        } else {
          console.log('翻译组件加载失败');
        }
      },
      getinitstatus() {
        var params = new URLSearchParams();
        params.append('cmd', 'GetStatus');
        params.append('lang', this.lang);
        this.$http.post(this.actionurl, params).then((res) => {
          this.IsUseRackLayeroptions = res.data.Data;
          this.IsUseRackoptions = res.data.Data;
          this.Statusoptions = res.data.Data;
        });
      },
      getneworold() {
        var params = new URLSearchParams();
        params.append('cmd', 'GetNewOrOld');
        params.append('lang', this.lang);
        this.$http.post(this.actionurl, params).then((res) => {
          this.NewOrOldoptions = res.data.Data;
        });
      },
      getproducttype() {
        var params = new URLSearchParams();
        params.append('cmd', 'GetProductType');
        params.append('lang', this.lang);
        this.$http.post(this.actionurl, params).then((res) => {
          this.ProductTypeoptions = res.data.Data;
        });
      },
      submitForm(formName) {
        // alert(this.fileList.length);
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.ruleForm.SumStorage < 0) {
              alert(this.translateWords.countTip);
              return;
            }
            if (this.ruleForm.CanBeUseStorage < 0) {
              alert(this.translateWords.countTip);
              return;
            }
            if (this.ruleForm.ProductType == 0 || this.ruleForm.ProductType == '') {
              alert(this.translateWords.ProductTypeTip);
              return;
            }

            if (this.ruleForm.PositionId == 0 || this.ruleForm.PositionId == '') {
              alert(this.translateWords.selectRoom);
              return;
            }
            if (this.ruleForm.RackId == 0 || this.ruleForm.RackId == '') {
              alert(this.translateWords.selectRack);
              return;
            }
            // if(this.ruleForm.ProductName.indexOf('&')>-1)
            // {
            //     alert(this.translateWords.containtab+":&");
            //    return;
            // }

            let fd = new FormData();
            for (var key in this.ruleForm) {
              fd.append(key, this.ruleForm[key]);
            }
            fd.append('lang', this.lang);
            fd.append('uid', this.uid);
            if (this.Type == 'add') fd.append('Sys_Guid', '');
            else fd.append('Sys_Guid', this.Sys_Guid);
            fd.append('cmd', 'SaveSample');
            fd.append('optype', this.Type);
            this.imgurls = '';
            if (this.fileList.length > 0) {
              for (var i = 0; i < this.fileList.length; i++) {
                this.imgurls += this.fileList[i].url + ',';
              }
            }
            fd.append('imgurls', this.imgurls);
            var that = this;
            this.$http.post(this.actionurl, fd).then((res) => {
              if (res.data.Message == '') {
                //  this.$message({
                //   message: '保存成功',
                //   type: 'success'
                // });
                alert(that.translateWords.saveSuccess);
                this.resetForm('ruleForm');
                this.imgurls = '';
                this.fileList = [];

                this.$emit('closedialog');
              } else {
                alert(res.data.Message);
                // this.$message({
                //   message: res.data.Message,
                //   type: "error"
                // });
              }
            });
          } else {
            return false;
          }
        });
      },
      showwptable() {
        this.showwp = true;
        this.$nextTick(function() {
          this.$refs.WP.init();
          this.$refs.WP.getData(1, 10);
        });
      },
      setwpbutton(e) {
        this.showwpbutton = e;
      },
      setwp(e) {
        this.showwp = e;
      },
      handlePreview(file) {},
      selectvalue(val, type) {
        if (type == 'PositionId') {
          this.rackid = '';
          this.RackLayer = '';
          this.getrack(val);
          this.ruleForm.RackId = '';
        }
      },
      initproduct(type, rowjson) {
        this.Type = type;

        this.resetForm('ruleForm');
        this.fileList = [];
        var params = new URLSearchParams();
        params.append('lang', this.lang);
        params.append('uid', this.uid);
        params.append('cmd', 'InitSampleDrop');
        this.$http.post(this.actionurl, params).then((res) => {
          if (res.data.Message == '') {
            this.x_PositionIdoptions = res.data.Data.LoadDropPosition;
            this.NewOrOldoptions = res.data.Data.LoadDropNewOrOld;
            this.Statusoptions = res.data.Data.LoadDropStatus;
            this.ProductTypeoptions = res.data.Data.LoadDropProductType;

            if (type == 'edit') {
              this.Sys_Guid = rowjson.Sys_Guid;
              var model = rowjson;
              this.ruleForm.ProductName = model.ProductName;
              this.ruleForm.ProductCode = model.ProductCode;
              this.ruleForm.ModelType = model.ModelType;
              this.ruleForm.StorageNo = model.StorageNo;
              this.ruleForm.SupplierCode = model.SupplierCode;
              this.ruleForm.NewOrOld = Number(model.NewOrOldCode);

              this.ruleForm.RackId = Number(model.RackId);
              this.ruleForm.Remark = model.Remark;
              this.ruleForm.PositionId = Number(model.PositionId);
              this.ruleForm.Status = Number(model.StatusCode);

              this.ruleForm.SumStorage = model.SumStorage;
              this.ruleForm.CanBeUseStorage = model.CanBeUseStorage;
              this.fileList = model.ImgUrls;
              this.ruleForm.ProductType = Number(model.ProductTypeCode);
            } else this.Sys_Guid = '';
          } else {
            alert(this.translateWords.getDataError + res.data.Message);
            // this.$message({
            //   message: res.data.Message,
            //   type: "error"
            // });
          }
        });
      },
      getrack(positionid) {
        var that = this;
        var params = new URLSearchParams();
        params.append('positionid', positionid);
        params.append('cmd', 'GetRackByPositionId');
        this.$http.post(this.actionurl, params).then((res) => {
          if (res.data.Message == '') {
            this.RackIdoptions = res.data.Data;
            this.initproduct('edit', row);
          } else {
            // this.$message({
            //   message: res.data.Message,
            //   type: "error"
            // });
            alert(that.translateWords.getRackFail + res.data.Message);
          }
        });
      },
      newgetrack(row) {
        var that = this;
        var params = new URLSearchParams();
        params.append('positionid', row.PositionId);
        params.append('cmd', 'GetRackByPositionId');
        this.$http.post(this.actionurl, params).then((res) => {
          if (res.data.Message == '') {
            this.RackIdoptions = res.data.Data;
            this.initproduct('edit', row);
          } else {
            // this.$message({
            //   message: res.data.Message,
            //   type: "error"
            // });
            alert(that.translateWords.getRackFail + res.data.Message);
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      guid() {
        function S4() {
          return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
      },
      beforeupload(file) {
        var _this = this;
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
        const extension = testmsg === 'jpg' || testmsg === 'png' || testmsg === 'JPG' || testmsg === 'PNG';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!extension) {
          // _this.$message({
          //     message: "上传图片只能是jpg / png 格式!",
          //     type: "error"
          // });
          alert(_this.translateWords.uploadPicFail);
          return false;
        }
        if (!isLt2M) {
          // _this.$message({
          //     message: "图片最大2M!",
          //     type: "error"
          // });
          alert(_this.translateWord.picMaxSize);
          return false;
        }
        let fd = new FormData();
        fd.append('file', file);
        fd.append('cmd', 'UpLoadFile');
        fd.append('filename', _this.guid() + '.' + testmsg);
        _this.$http.post(_this.actionurl, fd).then(function(res) {
          if (res.data.Message == '') {
            if (res.data.Data != null) {
              _this.fileList.push(res.data.Data);
            }
            // _this.$message({
            //     message: '上传成功',
            //     type: 'success'
            // });
            // alert("上传成功");
          } else {
            // _this.$message({
            //     message: res.data.Message,
            //     type: "error"
            // });
            alert(_this.translateWord.uploadFail + ',' + res.data.Message);
          }
        });
      },
      beforeRemove(file) {
        var _this = this;
        var newlist = [];

        if (_this.fileList.length > 0) {
          for (var i = 0; i < _this.fileList.length; i++) {
            if (_this.fileList[i].name != file.name) {
              newlist.push(_this.fileList[i]);
            }
          }
          _this.fileList = [];
          _this.fileList = newlist;
        }
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .my-page {
    text-align: initial !important;
  }

  .page-title {
    font-weight: bold;
    margin: 0px 0px 15px;
    font-size: 26px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AddSample.vue